import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { DataTableDef, SelectionMode, Popover, Link } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues, useLocalizer } from "ui/hooks";
import { securityMessages } from "ui/screens/security/security.localization";

import { ISecurityRole } from "../SecurityRoles.state";

import styles from "./SecurityRolesGrid.module.scss";

export interface ISecurityRolesGrid {
  roles: ISecurityRole[];
  selectedRows: ISecurityRole[];
  onSelectionChanged: (rows: ISecurityRole[]) => void;
}

export const SecurityRolesGrid: React.FC<ISecurityRolesGrid> = ({ roles, selectedRows, onSelectionChanged }) => {
  const localizedValues = useLocalizedValues(() => ({
    refineSearch: commonMessages.info("refineSearch"),
    startSearch: commonMessages.info("startSearch"),
    role: securityMessages.property("role"),
    members: securityMessages.property("membersNumber"),
    tenant: securityMessages.property("tenant"),
    permissions: securityMessages.property("permissions")
  }));

  const localize = useLocalizer();

  return (
    <DataTableDef<ISecurityRole>
      data={roles}
      keySelector={row => row.roleId}
      emptyText={roles.length ? localizedValues.refineSearch : localizedValues.startSearch}
      selected={selectedRows}
      onSelectionChanged={onSelectionChanged}
      selectionMode={SelectionMode.single}
    >
      <DataTableDef.Column<ISecurityRole> id="roleName" title={localizedValues.role} sortable valueSelector={row => row.roleName}>
        {row => (
          <Popover hideOnClick anchor={<Link>{localize({ value: row.roleName })}</Link>} trigger="click">
            <div className={styles.permissions}>
              <p>{localizedValues.permissions}</p>
              <ul>
                {row.permissions.map((val, i) => (
                  <li key={i}>{localize(val.name.messageId)}</li>
                ))}
              </ul>
            </div>
          </Popover>
        )}
      </DataTableDef.Column>
      <DataTableDef.Column<ISecurityRole> id="membersNumber" title={localizedValues.members} sortable valueSelector={row => row.membersNumber}>
        {row => <RouterLink to={`/security/security-role-members?roleId=${row.roleId}&tenantId=${row.tenant.tenantId}`}>{row.membersNumber}</RouterLink>}
      </DataTableDef.Column>
      <DataTableDef.Column<ISecurityRole> id="tenantName" title={localizedValues.tenant} sortable valueSelector={row => row.tenant.tenantName}>
        {row => row.tenant.tenantName}
      </DataTableDef.Column>
    </DataTableDef>
  );
};
